const changeSomeThing = {
  namespaced: true,
  state: {
    loginWay: 0, // 登录方式切换
    model: 1, // 扫码方式
    identity: "", // 扫码id
    newSearchText: "", // 搜索关键字
  },
  mutations: {
    setLoginWay: (state, key) => {
      state.loginWay = key;
    },
    setModel: (state, key) => {
      state.model = key;
    },
    setIdentity: (state, key) => {
      state.identity = key;
    },
    setNewSearchText: (state, key) => {
      state.newSearchText = key;
    },
  },
  actions: {
    changeModel: ({ commit }, key) => {
      commit("setModel", key);
    },
  },
};
export default changeSomeThing;
